import type { TranslationMessages } from '../types';

export const dashboard: TranslationMessages = {
      name: 'Bảng điều khiển',
      more: 'Thêm',
      more_menu: 'Thêm Menu',
      monthly_revenue: 'Doanh thu hôm nay',
      month_history: 'Doanh thu theo giờ hôm nay',
      new_orders: 'Đơn hàng mới',
      pending_reviews: 'Đánh giá chờ duyệt',
      all_reviews: 'Xem tất cả đánh giá',
      new_customers: 'Khách hàng mới',
      all_customers: 'Xem tất cả khách hàng',
      pending_orders: 'Đơn hàng chờ duyệt',
      vs_yesterday: 'so với hôm qua',
      vs_previous_6_hours: 'so với 6 giờ trước',
      need_attention: 'Cần chú ý',
      no_data_available: 'Chưa có dữ liệu',
      todays_goals: 'Mục tiêu hôm nay',
      goals_last_6_hours: 'Mục tiêu 6 giờ qua',
      performance: 'Hiệu suất',
      revenue_last_6_hours: 'Doanh thu 6 giờ qua',
      orders_last_6_hours: 'Đơn hàng 6 giờ qua',
      customers_last_6_hours: 'Khách hàng 6 giờ qua',
      pending_orders_last_6_hours: 'Đơn hàng chờ duyệt (6 giờ qua)',
      revenue_last_6_hours_chart: 'Doanh thu theo giờ (6 giờ qua)',
      top_products_last_6_hours: 'Sản phẩm hàng đầu (6 giờ qua)',
      orders_needing_attention: 'Đơn hàng cần chú ý',
      avg_processing_time: 'Thời gian xử lý TB',
      satisfaction_rate: 'Tỷ lệ hài lòng',
      orders_per_hour: 'Đơn hàng/giờ',
      default_customer: 'Khách hàng',
      default_product: 'Sản phẩm',
      time_just_now: 'Vừa xong',
      time_minutes_ago: 'phút trước',
      time_hours_ago: 'giờ trước',
      time_days_ago: 'ngày trước',
      top_products: {
        sold: 'Bán Được',
      },
      error_loading: 'Lỗi khi tải dữ liệu',
      network_error: 'Lỗi mạng',
      network_error_help: 'Vui lòng kiểm tra:',
      network_error_check_server: 'Máy chủ API đang chạy',
      network_error_check_connection: 'Kết nối mạng của bạn đang hoạt động',
      network_error_check_proxy: 'Proxy API được cấu hình đúng',
      error_saving: 'Không thể lưu',
      edit_customer_description: 'Cập nhật thông tin khách hàng',
      create_customer_description: 'Tạo tài khoản khách hàng mới',
      showing: 'Hiển thị',
      to: 'đến',
      of: 'của',
      page: 'Trang',
      customers: 'khách hàng',
      welcome: {
        title: 'Chào mừng đến với Bảng Điều Khiển NEKO POS',
        subtitle: 'Quản lý hoạt động cửa hàng cà phê của bạn một cách hiệu quả',
        ra_button: 'React Admin',
        demo_button: 'Demo',
      },
      products: {
        error_loading: 'Lỗi khi tải sản phẩm:',
        recipe_based: 'Dựa trên công thức',
        stock_based: 'Dựa trên kho',
      },
      inventory: {
        name: 'Tồn kho',
      },
      previewMode: {
        label: 'CHẾ ĐỘ XEM TRƯỚC',
        message:
          'Làm mờ dữ liệu nhạy cảm đang hoạt động. Đây là cửa sổ xem trước, không phải bảng điều khiển thực tế.',
        exitPreview: 'Thoát Xem trước',
        exit: 'Thoát',
      },
      customer_reviews: {
        name: 'Đánh giá khách hàng |||| Đánh giá khách hàng',
      },
      product_categories: {
        title: 'Danh mục sản phẩm',
        subtitle: 'Quản lý danh mục sản phẩm để tổ chức sản phẩm của bạn',
        loading: 'Đang tải danh mục sản phẩm...',
        new_category: 'Danh mục mới',
        search_placeholder: 'Tìm kiếm danh mục...',
        no_categories:
          'Chưa có danh mục sản phẩm nào. Tạo danh mục đầu tiên của bạn!',
        no_results: 'Không tìm thấy danh mục nào phù hợp với tìm kiếm của bạn.',
        load_error: 'Không thể tải danh mục sản phẩm',
        delete_confirm: 'Bạn có chắc chắn muốn xóa danh mục này không?',
        delete_error: 'Không thể xóa danh mục. Vui lòng thử lại.',
        category_details: 'Chi tiết danh mục',
        name_placeholder: 'Nhập tên danh mục...',
        edit_subtitle: 'Cập nhật thông tin danh mục',
        create_subtitle: 'Tạo danh mục sản phẩm mới',
        save_error: 'Không thể lưu danh mục. Vui lòng thử lại.',
      },
      menus: {
        title: 'Menu',
        subtitle: 'Quản lý menu sản phẩm của bạn',
        loading: 'Đang tải menu...',
        new_menu: 'Menu mới',
        search_placeholder: 'Tìm kiếm menu...',
        no_menus: 'Chưa có menu nào. Tạo menu đầu tiên của bạn!',
        no_results: 'Không tìm thấy menu',
        load_error: 'Không thể tải menu',
        delete_confirm: 'Bạn có chắc chắn muốn xóa menu này không?',
        delete_error: 'Không thể xóa menu',
        menu_details: 'Chi tiết Menu',
        name_placeholder: 'Nhập tên menu',
        description_placeholder: 'Nhập mô tả menu (tùy chọn)',
        edit_subtitle: 'Chỉnh sửa cấu hình menu',
        create_subtitle: 'Tạo menu mới',
        save_error: 'Không thể lưu menu',
        select_categories: 'Chọn Danh mục',
        exclude_products: 'Bỏ chọn sản phẩm để loại trừ chúng khỏi menu này:',
        products: 'sản phẩm',
        no_categories: 'Chưa có danh mục nào. Vui lòng tạo danh mục trước.',
        active: 'Hoạt động',
        categories_count: 'Danh mục',
        menus: 'menu',
        exclude_categories: 'Loại trừ Danh mục',
        exclude_categories_description:
          'Loại trừ sản phẩm từ các danh mục cụ thể khỏi menu này (ví dụ: loại trừ danh mục "Dịch vụ" khỏi menu Dịch vụ)',
        exclude_category_label: 'Loại trừ danh mục "%{name}"',
        excluding_categories: 'Đang loại trừ danh mục: %{names}',
      },
      settings: {
        title: 'Cài đặt',
      },
      grab: {
        mappings: {
          title: 'Đồng bộ Sản phẩm',
        },
        settings: {
          title: 'Cài đặt Tích hợp Grab',
        },
        sync: {
          title: 'Bảng Đồng bộ Menu',
        },
      },
      navigation_groups: {
        sales_orders: 'Bán hàng & Đơn hàng',
        marketing: 'Tiếp thị',
        products: 'Sản phẩm',
        recipes_ingredients: 'Công thức & Nguyên liệu',
        inventory: 'Tồn kho',
        costs: 'Chi phí',
        staff: 'Nhân viên',
        project_management: 'Quản lý Dự án',
        settings: 'Cài đặt',
      },
    };
